import { Stop } from "../../parsegenerated";

export class StopModel {
  stop_id?: string;
  stop_lon?: number;
  stop_lat?: number;
  stop_name?: string;
}

export function toStopModel(data: Stop): StopModel {
  return {
    stop_id: data.stop_id,
    stop_lon: Number.parseFloat(data.stop_lon ?? ""),
    stop_lat: Number.parseFloat(data.stop_lat ?? ""),
    stop_name: data.stop_name,
  };
}
